interface FooterProps {
  tournamentCount: number;
  setCount: number;
}

export default function Footer({ tournamentCount, setCount }: FooterProps) {
  const year = new Date().getFullYear();
  return (
    <footer className="text-center text-muted small border-top bg-body-tertiary py-1 px-2">
      <div>
        Browsing {tournamentCount.toLocaleString()} tournament
        {tournamentCount === 1 ? "" : "s"} and {setCount.toLocaleString()} set
        {setCount === 1 ? "" : "s"}.
      </div>
      <div>
        &copy; {year} SlpMeUp &middot; <a href="mailto:email@dalton.dog">email@dalton.dog</a>
      </div>
      <div>
        <a href="/privacy">Privacy Policy</a> &middot; <a href="/terms">Terms of Service</a>{" "}
        &middot; <a href="/cookies">Cookie Policy</a>
      </div>
    </footer>
  );
}
